<app-header></app-header>
<!-- Content -->
<div id="content">
  <section class="container  pb-3 availability-details">
    <div class="row">
      <div class="col mb-2 mt-4 head-txt">
        <div class="row">
          <div class="col-sm-12 main-txt p-0">{{ cruise.Nights }} {{ cruise.FriendlyCruiseName }} <span
              class="ak-star star pl-2"></span> <span class="ak-star star"></span>
            <span class="ak-star star"></span><span class="ak-star star"></span>
          </div>
          <div class="col-sm-12 sub-txt p-0">
            <span class="ak-location"></span>
            Departing from: {{ cruise.EmbarkFrom }}
          </div>
        </div>
      </div>
    </div>


    <div class="row oceanview mb-4 d-flex justify-content-between">
      <div class="left d-flex justify-content-between">
        <div class="left-img">
          <img src="{{imagename}}" (click)="openGallery(false)">
        </div>
        <div class="right-img d-flex flex-column">
          <div class="d-flex justify-content-between" [class.mt-2]="i!=0"
            *ngFor="let p of cruise?.gallery?.slice(0, cruise?.gallery?.length/2);let i = index;">
            <div *ngIf="methodeven(i)" class="thumb"><img [src]="cruise.gallery[i].ImageURL"></div>
            <div *ngIf="methododd(i+1)" class="thumb"><img [src]="cruise.gallery[i+1].ImageURL">
              <div *ngIf="i+1==((cruise.gallery.length/2-1))"
                class="viewmore d-flex flex-column justify-content-center align-items-center"
                (click)="openGallery(cruise.gallery)">
                <span class="ak-add"></span>
                <p> View All({{cruise.gallery.length}})</p>
              </div>
            </div>
            <!-- <div class="thumb"><img src="assets/images/banner-pic/3.jpeg"></div> -->
          </div>

        </div>
        <!-- <div class="right-img d-flex flex-column">
          <div class="d-flex justify-content-between">
            <div class="thumb"><img src="assets/images/banner-pic/2.jpeg"></div>
            <div class="thumb"><img src="assets/images/banner-pic/3.jpeg"></div>
          </div>
          <div class="d-flex justify-content-between mt-2">
            <div class="thumb"><img src="assets/images/banner-pic/4.jpeg"></div>
            <div class="thumb"><img src="assets/images/banner-pic/5.jpeg"></div>
          </div>

          <div class="d-flex justify-content-between mt-2">
            <div class="thumb"><img src="assets/images/banner-pic/2.jpeg"></div>
            <div class="thumb"><img src="assets/images/banner-pic/3.jpeg"></div>
          </div>

          <div class="d-flex justify-content-between mt-2">
            <div class="thumb"><img src="assets/images/banner-pic/4.jpeg"></div>
            <div class="thumb">
              <img src="assets/images/banner-pic/5.jpeg">
              <div class="viewmore d-flex flex-column justify-content-center align-items-center">
                <span class="ak-add"></span>
                <p> View All(25)</p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="right">


        <div class="col btm-bdr pb-2">
          <div class="row name">
            <b>{{ cruisegal.cabintypeF }}</b>
          </div>
          <div class="row detail mt-3 d-flex justify-content-between align-items-center">
            <div class="big d-flex flex-column justify-content-between">
              <div class="d-flex flex-row">
                <!-- <b>2</b> <span class="date"> may'10</span> -->
                <span class="date"> {{cruise.startDate}}</span>
              </div>
              <!-- <span class="day">thursday</span> -->
              <span class="day">{{cruise.EmbarkFrom}} from {{cruise.EmbarkTo}}</span>
            </div>
            <div class="small ">
              <div> {{cruise.Nights}}</div>
              <!-- <div><b>2</b> night</div> -->
            </div>
            <div class="big d-flex flex-column justify-content-between">
              <div class="d-flex flex-row">
                <span class="date"> {{cruise.endDate}}</span>
                <!-- <b>2</b> <span class="date"> may'10</span> -->
              </div>
              <!-- <span class="day">thursday</span> -->
              <span class="day">{{cruise.EmbarkFrom}} from {{cruise.EmbarkTo}}</span>
            </div>
          </div>
          <div class="row pax-detail mt-3">
            <b>{{room.adults}}</b><span>Adult(s), </span> <b>{{room.childs}}</b><span> child(s) | 1 x
              {{cruisegal.cabintypeF}}</span>
          </div>
        </div>

        <div class="col btm-bdr pt-3 pb-3">
          <div class="row d-flex flex-row justify-content-between">
            <div class="cancel">
              <span class="ak-check"></span>
              25% cancellation fee - beyound 31 Days
            </div>
            <div style="cursor: pointer;">
              <a data-toggle="modal" data-target="#cancellationPolicy"> cancellation policy</a>
            </div>
          </div>
        </div>

        <div class="col btm-bdr pt-3 pb-3 book-btn">
          <div class="row  d-flex flex-row justify-content-end align-items-end">
            <div class="d-flex flex-column justify-content-end align-items-end amount">
              <span class="line">₹ {{
                (cruisegal.totalbase + cruisegal.totalport + cruisegal.gst + cruisegal.gratuity + cruisegal.fuelsurcharge - cruisegal.comm)
                |number }}</span>
              <span class="d-flex flex-row  justify-content-end align-items-end cabin">
                <p>per cabin</p>
                <b> ₹ {{
                  (cruisegal.totalbase + cruisegal.totalport + cruisegal.gst + cruisegal.gratuity + cruisegal.fuelsurcharge - cruisegal.comm)
                  |number }}</b>
              </span>
            </div>
            <div class="ml-4">
              <button type="button" class="btn book-now" (click)="bookcruise(cruise, dates, cruisegal.cabintype)">Book
                Now</button>
            </div>
          </div>
        </div>

        <div class="col pt-3 pb-3 ">
          <div class="row d-flex flex-row justify-content-between align-items-center bottom-btn">
            <button type="button" class="btn book-now update" data-toggle="modal" data-target="#exampleModalCenter"
              (click)="showdata(cruiseData[4])">Change Dates</button>
            <button type="button" class="btn book-now send" data-toggle="modal" data-target="#exampleModalCenterSend"
              (click)="openSendQuery(cruise)">send query</button>
          </div>

          <div class="modal fade" id="cancellationPolicy" tabindex="-1" role="dialog"
            aria-labelledby="cancellationPolicy" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLongTitle">Policy</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body" *ngFor="let plan of cruise.cancellationPolicy">
                  <h3 class="text-3 mb-2 mt-2 "><b>{{plan.policyTitle}}</b></h3>
                  <div class="text-2 mb-2" *ngFor="let day of plan.daywise.split('`')"> {{day}} </div>
                  <div class="text-2 mb-2" *ngFor="let freeText of plan.freeText.split('`')"> {{freeText}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLongTitle">Select Sailing Dates</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <!-- <select class="form-select form form-select-lg mb-3" aria-label=".form-select-lg example" name="Room"
                    (change)="voucher_validate($event)" [(ngModel)]="Room" id="Room" required>
                    <option [selected]="true" value="">Select Cabin</option>
                    <option *ngFor="let vessels of vessel;" value="{{vessels.name}}"> {{vessels.name}}</option>
                  </select> -->

                  <select class="form-select form form-select-sm" aria-label=".form-select-sm example" name="sailDateup"
                    [(ngModel)]="sailDateup" id="sailDateup" required>
                    <option [selected]="true" value="">Select Date</option>
                    <option *ngFor="let p of sailMonths;" value="{{p.sailingday}}"> {{p.sailingday}}</option>
                  </select>
                  <!-- <select class="form-select form form-select-sm" aria-label=".form-select-sm example"
                    name="selectedFARE" [(ngModel)]="selectedFARE" id="selected" required *ngIf="farebasis.length > 0">
                    <option [selected]="true" value="">Select Fare Type</option>
                    <option *ngFor="let fb of farebasis;" value="{{fb.fareBasis}}"> {{fb.fareBasisDesc}}</option>
                  </select> -->
                </div>
                <div class="modal-footer pop">
                  <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                  <button type="button" class="btn btn-primary btn btn-primary btn-lg book-now btn-block"
                    (click)="upgrade()">Submit</button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal fade" id="exampleModalCenterSend" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLongTitle">Our Expert will Call you back</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <input type="text " placeholder="Name *" class="form-control mb-3 " aria-describedby="emailHelp"
                    [(ngModel)]="lead.name " />
                  <input type="text " placeholder="Contact Number *" class="form-control mb-3 "
                    aria-describedby="emailHelp" [(ngModel)]="lead.phone " />
                  <input type="text " placeholder="E-Mail ID *" class="form-control mb-3 " aria-describedby="emailHelp"
                    [(ngModel)]="lead.email " />
                  <input type="text " placeholder="Your City *" class="form-control mb-3 " aria-describedby="emailHelp"
                    [(ngModel)]="lead.city " />

                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="exampleCheck1" (click)="termc($event)">
                    <label class="form-check-label" for="exampleCheck1">I authorize akbartravels to contact me and have
                      read the Terms and Conditions.*</label>
                  </div>

                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="exampleCheck2" (click)="termc($event)">
                    <label class="form-check-label" for="exampleCheck2">I agree to receive updates & offers from
                      akbartravels</label>
                  </div>


                </div>
                <div class="modal-footer pop">
                  <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                  <button type="button" class="btn btn-primary book-now  btn-lg btn-block"
                    (click)="createLead() ">submit</button>
                </div>
              </div>
            </div>
          </div>



        </div>


      </div>
    </div>


    <div class="row scrollcla">
      <div class="card col dtl-deck">
        <div class="header">
          Available Cabins
        </div>
        <div *ngFor="let cb of cruise.cabins; let i = index">
          <div class="row">
            <div class="inr-head col d-flex flex-row justify-content-between pt-2 pb-2 mt-3  mb-3 text-4">
              <div class="left">
                <b>{{ cb.FriendlyName }}</b>
              </div>
              <!-- <div class="right">
              10 Room left
            </div> -->
            </div>
          </div>
          <div class="inr-content ">
            <div class="pr-o pl-0 mb-3 less-padding col d-flex justify-content-between res-col">
              <div class="thumb-img">
                <img src="{{ cb.ImageURL }}">
              </div>
              <div class="box-xl  d-flex flex-column  justify-content-start  align-items-start">
                <div class="pb-3 d-flex flex-row align-items-center">
                  <span class="ak-bed icon"></span>
                  <p class="pl-2">
                    {{cb.Heading.split('~')[1]}}</p>
                </div>

                <div class="pb-3 d-flex flex-row align-items-center">
                  <span class="ak-user icon"></span>
                  <p class="pl-2">{{cb.Heading.split('~')[0]}}</p>
                </div>

                <div class="pb-3 d-flex flex-row align-items-center">
                  <span class="ak-set-square icon"></span>
                  <p class="pl-2">{{cb.Heading.split('~')[2]}}</p>
                </div>
              </div>
              <div class="box-xl">
                <h6 [innerHtml]="cb.Info">
                </h6>
                <!-- <div class="fee">
                <span class="ak-check"></span>
                25% Cancellation fee - Beyond 31 Days
              </div> -->
              </div>
              <div class="box-xs">
                <div class="price d-flex flex-column">
                  <div class="sml-txt"
                    *ngIf="cruisegal.cabintype.toUpperCase().indexOf(cb.CategoryName.toUpperCase()) > -1">Starting Price
                  </div>
                  <b *ngIf="cruisegal.cabintype.toUpperCase().indexOf(cb.CategoryName.toUpperCase()) > -1"> ₹ {{
                    (cruisegal.totalbase + cruisegal.totalport + cruisegal.gst + cruisegal.gratuity + cruisegal.fuelsurcharge - cruisegal.comm)
                    |number }}</b>

                  <div class="btn mt-3"
                    *ngIf="cruisegal.cabintype.toUpperCase().indexOf(cb.CategoryName.toUpperCase()) > -1">
                    Selected Cabin
                  </div>

                  <div class="btn-line mt-3"
                    *ngIf="cruisegal.cabintype.toUpperCase().indexOf(cb.CategoryName.toUpperCase()) == -1"
                    (click)="updateSearch(cb.CategoryName)">Check Rates
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="inr-head col d-flex flex-row justify-content-between  pt-2 pb-2 mt-3  mb-3">
            <div class="left">Balcony</div>
          </div>
        </div>
        <div class="inr-content ">
          <div class="pr-o pl-0 mb-3 less-padding col d-flex justify-content-between res-col">
            <div class="thumb-img">
              <img src="assets/images/balcony.jpg">
            </div>
            <div class="box-xl  d-flex flex-column  justify-content-start  align-items-start">
              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-bed icon"></span>
                <p class="pl-2">1 Double Bed or 2 Single Beds</p>
              </div>

              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-user icon"></span>
                <p class="pl-2">Max 4 guests</p>
              </div>

              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-set-square icon"></span>
                <p class="pl-2">Room Size - 710 square feet</p>
              </div>


              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-balcony icon"></span>
                <p class="pl-2">Balcony Size - 710 square feet</p>
              </div>


            </div>
            <div class="box-xl">
              <h6>
                A luxurious room with a balcony
                with stunning ocean views
              </h6>
              <div class="fee">
                <span class="ak-check"></span>
                25% Cancellation fee - Beyond 31 Days
              </div>
            </div>
            <div class="box-xs">
              <div class="price d-flex flex-column">
                <div class="sml-txt">Starting Price</div>
                <b>₹ 23,307</b>

                <div class="btn-line mt-3">
                  Check Rates
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="inr-head col d-flex flex-row justify-content-between  pt-2 pb-2 mt-3  mb-3">
            <div class="left">
              OceanView
            </div>
          </div>
        </div>
        <div class="inr-content ">
          <div class="pr-o pl-0 mb-3 less-padding col d-flex justify-content-between res-col">
            <div class="thumb-img">
              <img src="assets/images/oceanView.jpg">
            </div>
            <div class="box-xl  d-flex flex-column  justify-content-start  align-items-start">
              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-bed icon"></span>
                <p class="pl-2">1 Double Bed or 2 Single Beds</p>
              </div>

              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-user icon"></span>
                <p class="pl-2">Max 4 guests</p>
              </div>

              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-set-square icon"></span>
                <p class="pl-2">Room Size - 710 square feet</p>
              </div>
            </div>
            <div class="box-xl">
              <h6>
                Enjoy spectacular views of the ocean from your room.
              </h6>
              <div class="fee">
                <span class="ak-check"></span>
                25% Cancellation fee - Beyond 31 Days
              </div>
            </div>
            <div class="box-xs">
              <div class="price d-flex flex-column">
                <div class="sml-txt">Starting Price</div>
                <b>₹ 23,307</b>

                <div class="btn-line mt-3">
                  Check Rates
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="inr-head col d-flex flex-row justify-content-between  pt-2 pb-2 mt-3 mt-3  mb-3">
            <div class="left">
              Suite
            </div>
          </div>
        </div>
        <div class="inr-content ">
          <div class="pr-o pl-0 mb-3 less-padding col d-flex justify-content-between res-col">
            <div class="thumb-img">
              <img src="assets/images/suite.jpg">
            </div>
            <div class="box-xl  d-flex flex-column  justify-content-start  align-items-start">
              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-bed icon"></span>
                <p class="pl-2">1 Double Bed or 2 Single Beds</p>
              </div>

              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-user icon"></span>
                <p class="pl-2">Max 4 guests</p>
              </div>

              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-set-square icon"></span>
                <p class="pl-2">Room Size - 710 square feet</p>
              </div>


              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-balcony icon"></span>
                <p class="pl-2">Balcony Size - 710 square feet</p>
              </div>
            </div>
            <div class="box-xl">
              <h6>
                An uber-luxurious suite for a breathtaking cruising experience.
              </h6>
              <div class="fee">
                <span class="ak-check"></span>
                25% Cancellation fee - Beyond 31 Days
              </div>
            </div>
            <div class="box-xs">
              <div class="price d-flex flex-column">
                <div class="sml-txt">Starting Price</div>
                <b>₹ 23,307</b>

                <div class="btn-line mt-3">
                  Check Rates
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="inr-head col d-flex flex-row justify-content-between pt-2 pb-2 mb-3">
            <div class="left">
              Chairmans Suite
            </div>
          </div>
        </div>
        <div class="inr-content">
          <div class="pr-o pl-0 mb-3 less-padding col d-flex justify-content-between res-col">
            <div class="thumb-img">
              <img src="assets/images/chairmans-suite.jpg">
            </div>
            <div class="box-xl  d-flex flex-column  justify-content-start  align-items-start">
              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-bed icon"></span>
                <p class="pl-2">1 Double Bed or 2 Single Beds</p>
              </div>

              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-user icon"></span>
                <p class="pl-2">Max 4 guests</p>
              </div>

              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-set-square icon"></span>
                <p class="pl-2">Room Size - 710 square feet</p>
              </div>


              <div class="pb-3 d-flex flex-row align-items-center">
                <span class="ak-balcony icon"></span>
                <p class="pl-2">Balcony Size - 710 square feet</p>
              </div>
            </div>
            <div class="box-xl">
              <h6>
                An uber-luxurious suite for a breathtaking cruising experience.
              </h6>
              <div class="fee">
                <span class="ak-check"></span>
                25% Cancellation fee - Beyond 31 Days
              </div>
            </div>
            <div class="box-xs">
              <div class="price d-flex flex-column">
                <div class="sml-txt">Starting Price</div>
                <b>₹ 23,307</b>

                <div class="btn-line mt-3">
                  Check Rates
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="row  btm-bdr"></div>
        <!-- <div class="deal col d-flex flex-row justify-content-start  align-items-center">
          <span class=" mt-2 mb-2">DEAL</span>
          <p>Save Big Today with ZERO Convenience Fee</p>
        </div> -->
      </div>
    </div>

    <div class="row mt-4 mb-4 inr-tab">
      <div id="horizontalTab" class="resp-htabs">
        <ul class="resp-tabs-list d-flex flex-row justify-content-center align-items-center">
          <li>Cruise Highlights</li>
          <li> Onboard experience</li>
          <li> Amenities </li>
          <li> Itinerary</li>
          <li> Available Offers</li>
        </ul>

        <div class="resp-tabs-container">
          <div>
            <h3>Top Highlights</h3>
            <p [innerHtml]="cruise.ShipDesc "></p>
          </div>





          <div class="exp">
            <div *ngFor="let p of cruise.onboard ">
              <h3>Salon & Fitness At Sea</h3>
              <div class="col d-flex flex-column less-padding btm-bdr mb-4">
                <div class="d-flex flex-row  row p-3">
                  <div class="col-sm-9 p-0 pr-3">
                    <p [innerHtml]="p.Info "></p>
                  </div>
                  <div class="col-sm-3 cat-img p-0 d-flex flex-column">
                    <div class="container-img">
                      <img src="{{ p.ImageURL }} ">
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <!-- <h3>BARS & LOUNGES</h3>
            <div class="col d-flex flex-column less-padding  btm-bdr mb-4">
              <div class="d-flex flex-row  row p-3">
                <div class="col-sm-9 p-0 pr-3">
                  <p>Whether you want to enjoy an intimate evening over drinks with the ones closest to you, or
                    whether you want to kick back with a tropical cooler and lounge by the pool deck, Empress
                    includes a plethora of bars & lounges that are perfectly suited to every occasion. Each bar
                    includes premium spirits from all over the world, so you can experience the finest of liquor at
                    its finest. </p>
                </div>
                <div class="col-sm-3 cat-img p-0 d-flex flex-column">
                  <div class="container-img">
                    <img src="assets/images/bar.jpeg">
                  </div>
                </div>
              </div>
            </div>


            <h3>DINING</h3>

            <div class="col d-flex flex-column less-padding  btm-bdr mb-4">
              <div class="d-flex flex-row  row p-3">
                <div class="col-sm-9 p-0 pr-3">
                  <p>When you cruise with us, you are truly spoilt for choice when it comes to dining experiences.
                    From oriental to continental, to Mughlai, to Indian street food, believe us when we say we’ve
                    got it all. Whether you want to treat yourself to a fine dining experience, or whether you
                    simply want to indulge and satisfy your cravings, we’ve got just the right eatery for you. Take
                    your taste buds on a Southeast Asian tour with our in-house oriental restaurant featuring
                    delicacies from Japan to Thailand. Or experience a lavish meal curated by our talented in-house
                    chefs, or, if you are looking for something quick, substantial, and satisfying, choose from a
                    number of our food plazas that offer the best of Tandoors, Pizzas. Pastas, Grills, and even
                    mouth-watering Indian street food! We also have a special section of Jain Food, so that you can
                    enjoy a delightful meal while sticking to your dietary preferences. If you’ve got a sweet tooth,
                    you’re in luck as we offer a range of confectionery and sweet delights. So go ahead and indulge
                    yourself, after all, you’re on vacation! </p>

                  <p>
                    We at Cordelia Cruises take pride in India’s cultural values and ethos, and our team of
                    dedicated staff members represents those very values to offer you premium quality service. The
                    Empress gets ready to set sail soon, and we are incredibly excited to see you again. So, mark
                    your calendars, pack your bags, and get ready because the high seas are calling.
                  </p>
                </div>
                <div class="col-sm-3 cat-img p-0 d-flex flex-column">
                  <div class="container-img">
                    <img src="assets/images/dining.jpeg">
                  </div>
                </div>
              </div>
            </div>



            <h3>ENTERTAINMENT & NIGHTLIFE</h3>
            <div class="col d-flex flex-column less-padding  btm-bdr mb-4">
              <div class="d-flex flex-row  row p-3">
                <div class="col-sm-9 p-0 pr-3">
                  <p>From groovy nightclubs where you can dance the night away to Casinos brimming with
                    opportunities to get lucky, to sprawling amphitheaters where you can witness spectacular
                    performances, the choices for entertainment are ample onboard Empress. If you’re worried about
                    the kids getting bored, worry no more because Empress has designated special zones for kids &
                    teenagers, where they can enjoy a range of fun activities, and can also mix and mingle with
                    others their age. There’s always something exciting to do for every age group. </p>
                </div>
                <div class="col-sm-3 cat-img p-0 d-flex flex-column">
                  <div class="container-img">
                    <img src="assets/images/nightlife.jpeg">
                  </div>
                </div>
              </div>
            </div>



            <h3>KIDS & TEENAGERS</h3>
            <div class="col d-flex flex-column less-padding  btm-bdr mb-4">
              <div class="d-flex flex-row  row p-3">
                <div class="col-sm-9 p-0 pr-3">
                  <p>Some of the Games being Played at the Kids Academy are</p>
                  <ul class="option">
                    <li>Aliens Oxygen</li>
                    <li>Animal Actions
                    </li>
                    <li>Balance Beam Fun
                    </li>
                    <li>Balloon Volleyball</li>
                    <li>Barnyard</li>
                    <li>Bean bag toss</li>
                    <li>Soccer Shoot Out</li>
                    <li>Castle Ball</li>
                    <li>Cone Knockdown Challenge</li>
                    <li>Dinosaur 4 corners</li>
                    <li>Dragon dodge</li>
                    <li>Mirror dancing</li>
                    <li>Disco Balloon challenge</li>
                    <li>Freeze dancing</li>
                    <li>Fishing relay</li>
                    <li>Follow the Spy</li>
                    <li>Freeze tag</li>
                    <li>Fruit salad</li>
                    <li>In room color hunt</li>
                    <li>King of the Jungle</li>
                    <li>Kryptonite Crash</li>
                    <li>On the beach In the Water</li>
                  </ul>
                </div>
                <div class="col-sm-3 cat-img p-0 d-flex flex-column">
                  <div class="container-img">
                    <img src="assets/images/kids.jpg">
                  </div>
                </div>
              </div>
            </div>
            <h3>SPA</h3>
            <div class="col d-flex flex-column less-padding">
              <div class="d-flex flex-row  row p-3">
                <div class="col-sm-9 p-0 pr-3">
                  <p>As if a cruise vacation was not rejuvenating enough, Cordelia Cruises takes rest and relaxation
                    to a whole new level with an onboard spa. Imagine relaxing at the sauna at our cruise ship spa
                    while taking in views of the endless ocean expanse. Could it get any better than that? There’s
                    no better way to prepare for your dreamy tropical vacation than by getting pampered luxuriously
                    at Cordelia Cruises onboard spa. So mark your calendars, pack your bags and get ready to
                    experience the ultimate in relaxation. Book your cruise with spa today!</p>
                  <p>
                    One of the many perks of booking a cruise with a spa is that your cruise vacation becomes a
                    heavenly getaway in every sense. With our onboard spa, you can truly escape the chaos of the
                    outside world. Serena Spa is Cordelia’ cruise ship spa which featured a wide range of body spa
                    treatments, right from deep tissue massages, to leisurely beauty treatments, a day at our cruise
                    ship spa is sure you make you feel brand new. Cordelia’s onboard spa includes a beauty room, a
                    dry sauna, a thermal lobby, thermal showers and a salon. If you wish to, you could even book the
                    thermal suite for which packages are available for both Singles and Couples.
                  </p>
                </div>
                <div class="col-sm-3 cat-img p-0 d-flex flex-column">
                  <div class="container-img">
                    <img src="assets/images/spa.jpeg">
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div class="amenities">
            <div class="col d-flex flex-row flex-wrap">

              <div class="ctgry d-flex flex-row justify-content-start align-items-center">
                <span class="ak-beach"></span>
                <p>beach</p>
              </div>

              <div class="ctgry d-flex flex-row justify-content-start align-items-center">
                <span class="ak-gym"></span>
                <p>Salon & Fitness At Sea</p>
              </div>

              <div class="ctgry d-flex flex-row justify-content-start align-items-center">
                <span class="ak-park"></span>
                <p>Kids & Teenagers</p>
              </div>
              <div class="ctgry d-flex flex-row justify-content-start align-items-center">
                <span class="ak-spa"></span>
                <p>spa</p>
              </div>
              <div class="ctgry d-flex flex-row justify-content-start align-items-center">
                <span class="ak-bar"></span>
                <p>Bars & Lounges</p>
              </div>
              <div class="ctgry d-flex flex-row justify-content-start align-items-center">
                <span class="ak-dining"></span>
                <p>Dining</p>
              </div>
              <div class="ctgry d-flex flex-row justify-content-start align-items-center">
                <span class="ak-night-life"></span>
                <p>Entertainment & Nightlife</p>
              </div>


            </div>
          </div>
          <div>
            <div class="d-flex flex-row  row p-3">
              <div class="col-sm-3 cat-img p-0 d-flex flex-column">
                <div class="container-img">
                  <img style="width: 100%;" src="{{cruise.itineraryImage }} ">
                </div>
              </div>
              <ul class="timeline col-sm-8">
                <li class="event " *ngFor="let itinerary of cruise.itinerary; let i=index ">
                  <div class="circleit">Day <br>{{ i + 1 }}</div>
                  <h3>{{ itinerary.BriefDesc }}</h3>
                  <p class="head">Departs</p>
                  <p class="content">{{ itinerary.Timings }}
                  </p>
                </li>
                <!-- <li class="event ">
                <div class="circleit">Day <br>2</div>
                <h3>DAY AT SEA</h3>
                  <p class="head">Departs</p>
                  <p class="content">Begin the day with a breakfast and experience the different fun and adventure activities we
                    have onboard for you and your family. Enjoy some fun family time at the pool. Indulge in the
                    gourmet cuisines and enjoy a cocktail at the Pool Bar. We have several activities and events
                    planned for the evenings. Don’t forget to try your luck at the casino.
                  </p>
              </li>
              <li class="event ">
                <div class="circleit">Day <br>3</div>
                <h3>ARRIVE IN GOA</h3>
                  <p class="head">Departs</p>
                  <p class="content">Arrive in Goa, today morning and disembark the cruise.(Arrive: 7:00:00AM)
                  </p>
              </li> -->

              </ul>
            </div>
          </div>
          <div>
            <div class="col-md-12 col-sm-12 col-xs-12 row">
              <div class=" col-md-4 col-sm-4 col-xs-4 mt-2 mb-2"
                *ngFor="let Offers of cruise.cabinOffers;let i = index;">
                <h3 class="text-3 mb-2 mt-2"
                  *ngIf="Offers.cabinupgrade.upgradetext!='' || Offers.onboardoffer!='' || Offers.partpayment.partoffer!=''">
                  {{Offers.cabin}}</h3>
                <div class="text-2 mb-2" *ngIf="Offers.cabinupgrade.upgradetext!=''"><b>Upgrade:</b>
                  {{Offers.cabinupgrade.upgradetext}} </div>
                <div class="text-2 mb-2" *ngIf="Offers.onboardoffer!=''"><b>Onboard:</b> {{Offers.onboardoffer}}
                </div>
                <div class="text-2 mb-2" *ngIf="Offers.partpayment.partoffer!=''"><b>Payment:</b>
                  {{Offers.partpayment.partoffer}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row  mb-4 fac-tab ">
      <div id="horizontalTab1" class="resp-htabs">
        <div class="col facilities">facilities</div>
        <ul class="resp-tabs-list d-flex flex-row  align-items-center">
          <li class="resp-tab-item" aria-controls="tab_item-0" role="tab"
            *ngFor="let onboard of cruise.onboard; let m=index " class="tablinks" style="cursor: pointer;"
            (click)="openactvty($event, onboard.CategoryName, onboard.ImageURL, onboard.Info) ">
            <span class="ak-gym pr-2"></span>
            {{ onboard.CategoryName }}
          </li>
          <!-- <li class="resp-tab-item resp-tab-active" aria-controls="tab_item-0" role="tab" ><span class="ak-gym pr-2"></span> Salon & Fitness At Sea</li>
          <li class="resp-tab-item" aria-controls="tab_item-1" role="tab"> <span class="ak-bar"></span> Bars & Lounges</li>
          <li class="resp-tab-item " aria-controls="tab_item-2" role="tab"> <span class="ak-dining"></span> Dining</li>
          <li class="resp-tab-item " aria-controls="tab_item-3" role="tab"> <span class="ak-night-life"></span> Entertainment & Nightlife</li>
          <li class="resp-tab-item " aria-controls="tab_item-4" role="tab"> <span class="ak-park"></span> Kids & Teenagers</li>
          <li class="resp-tab-item" aria-controls="tab_item-5" role="tab"> <span class="ak-spa"></span> Spa</li> -->
        </ul>
        <div class="resp-tabs-container">
          <div id=" Salon & Fitness At Sea" class="tabcontent ">
            <div class="col d-flex flex-column less-padding">
              <div class="d-flex flex-row  row p-3">
                <div class="col-sm-9 p-3">
                  <p [innerHtml]="htmlInfo "></p>
                </div>
                <div class="col-sm-3 cat-img p-2 d-flex flex-column">
                  <div class="container-img">
                    <img src="{{ imageurl }}">
                    <div class="img-txt">salon</div>
                  </div>
                  <!-- <div class="container-img">
                    <img src="assets/images/fitness.jpeg">
                    <div class="img-txt">Fitness</div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div id="Bars & Lounges" class="tabcontent ">
            <div class="col d-flex flex-column less-padding">
              <div class="d-flex flex-row  row p-3">
                <div class="col-sm-9 p-3">
                  <p [innerHtml]="htmlInfo "></p>
                </div>
                <div class="col-sm-3 cat-img p-2 d-flex flex-column">
                  <div class="container-img">
                    <img src="{{ imageurl }}">
                    <div class="img-txt">Bars & Lounges</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="Dining" class="tabcontent ">
            <div class="col d-flex flex-column less-padding">
              <div class="d-flex flex-row  row p-3">
                <div class="col-sm-9 p-3">
                  <p [innerHtml]="htmlInfo "></p>
                </div>
                <div class="col-sm-3 cat-img p-2 d-flex flex-column">
                  <div class="container-img">
                    <img src="{{ imageurl }}">
                    <div class="img-txt">Dining</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="Entertainment & Nightlife" class="tabcontent ">
            <div class="col d-flex flex-column less-padding">
              <div class="d-flex flex-row  row p-3">
                <div class="col-sm-9 p-3">
                  <p [innerHtml]="htmlInfo "></p>
                </div>
                <div class="col-sm-3 cat-img p-2 d-flex flex-column">
                  <div class="container-img">
                    <img src="{{ imageurl }}">
                    <div class="img-txt">Entertaiment & Nightlife</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="Kids & Teenagers" class="tabcontent ">
            <div class="col d-flex flex-column less-padding">
              <div class="d-flex flex-row  row p-3">
                <div class="col-sm-9 p-3">
                  <p [innerHtml]="htmlInfo "></p>
                </div>
                <div class="col-sm-3 cat-img p-2 d-flex flex-column">
                  <div class="container-img">
                    <img src="{{ imageurl }}">
                    <div class="img-txt">Kids & Teenagers</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="Spa" class="tabcontent ">
            <div class="col d-flex flex-column less-padding">
              <div class="d-flex flex-row row p-3">
                <div class="col-sm-9 p-3">
                  <p [innerHtml]="htmlInfo ">
                  </p>
                </div>
                <div class="col-sm-3 cat-img p-2 d-flex flex-column">
                  <div class="container-img">
                    <img src="{{ imageurl }}">
                    <div class="img-txt">spa</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 top-bdr pt-3 pb-3 mt-4 overview">
          <h3>Ship Overview</h3>
          <p [innerHtml]="cruise.ShipDesc "></p>
        </div>

      </div>
    </div>

  </section>
</div>
<app-footer></app-footer>
<div id="waitingIconHD" class="modal fade" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <button type="button" class="close" id="closeWaiting" data-dismiss="modal" aria-label="Close"> <span
          aria-hidden="true">&times;</span>
      </button>
      <div class="card-header">
        <div class="modal-body">
          <img src="./assets/images/progress.gif" style="margin-left: 40%; height:90px; width:90px">
        </div>
      </div>
    </div>
  </div>
</div>